import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  PushSubscriptionsLoadAction,
  PushSubscriptionsRegisterAction,
  PushSubscriptionsUnregisterAction,
} from '../../domains/pushSubscriptions/actions.types';

import type { PushSubscriptions } from './types';

const initialState: PushSubscriptions = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<
  PushSubscriptions,
  PushSubscriptionsLoadAction | PushSubscriptionsRegisterAction | PushSubscriptionsUnregisterAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUSH_SUBSCRIPTIONS.LOAD_PENDING':
      return setPending();
    case 'PUSH_SUBSCRIPTIONS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'PUSH_SUBSCRIPTIONS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'PUSH_SUBSCRIPTIONS.REGISTER_FULFILLED':
      return state.fulfilled ? setFulfilled(state.fulfilled.concat(action.payload)) : state;
    case 'PUSH_SUBSCRIPTIONS.UNREGISTER_FULFILLED':
      return state.fulfilled
        ? setFulfilled(
            state.fulfilled.filter(
              (subscription) =>
                !(
                  subscription.clientId === action.payload.clientId && subscription.endpoint === action.payload.endpoint
                )
            )
          )
        : state;
    default:
      return state;
  }
};

export default reducer;
